/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React from 'react';
import { createChatBotMessage as CreateChatBotMessage } from 'react-chatbot-kit';

function tryParseResponse(response: any) {
  let outputStr = response.output;

  // Step 2: Remove triple backticks and optional "json" keyword
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  outputStr = outputStr.replace(/^```json\n/, '').replace(/\n```$/, '');

  // Step 3: Parse the cleaned JSON string into an object
  try {
    const parsedData = JSON.parse(outputStr);

    console.log(parsedData);
    return parsedData;
  } catch (error) {
    console.error('Error parsing JSON:', error);
    throw error;
  }
}

interface LLMResponseObject {
  type: string;
  id?: string;
  taskId?: string;
  message: string;
}

interface LLMResponse {
  message: string;
  objects: LLMResponseObject[];
  units: string[];
}

interface ActionProviderProps {
  createChatBotMessage: typeof CreateChatBotMessage;
  setState: React.Dispatch<React.SetStateAction<unknown>>;
  children: React.ReactNode;
  state: any;
}

interface ChildProps {
  actions: {
    handleHello: () => void;
    sendToLLM: (message: any) => Promise<void>;
  };
}

const ActionProvider: React.FC<ActionProviderProps> = ({
  createChatBotMessage,
  setState,
  children,
  state,
}) => {
  const handleHello = () => {
    const botMessage = createChatBotMessage('Hello. Nice to meet you.', {});

    setState((prev: any) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));
  };

  const sendToLLM = async (message: any) => {
    // const thinkingMsg = createChatBotMessage('thinking...');
    console.log('!!!state', state);

    // setState((prev) => ({
    //   ...prev,
    //   messages: [...prev.messages, thinkingMsg],
    // }));

    const body = {
      message,
      sessionId: state.sessionId,
      user: state.user,
      projectId: state.projectId,
      buildingId: state.buildingId,
    };

    setState((prev: any) => ({
      ...prev,
      messages: [
        ...prev.messages,
        createChatBotMessage('Looking', { loading: true }),
      ],
    }));

    // 'https://chareny.n8n.urbanmix.tech/webhook/5b301534-edb2-4921-8df5-eacc635fdb42/chat',
    const llmurl =
      'https://4abec55c79cc.ngrok.app/webhook/5b301534-edb2-4921-8df5-eacc635fdb42/chat';

    console.log('sending', body);
    const response = await fetch(llmurl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    const json = await response.json();
    console.log('response', json);
    let data: LLMResponse | null = null;

    if (json.output) {
      data = json.output as LLMResponse;
    } else {
      try {
        data = json as LLMResponse;
      } catch {
        console.error('Error parsing JSON:', json);
      }
    }

    if (!data) {
      try {
        data = tryParseResponse(json) as LLMResponse;
      } catch (error) {
        console.error('Error parsing JSON:', error);
        if (error instanceof Error) {
          setState((prev: any) => ({
            ...prev,
            messages: [
              ...prev.messages,
              createChatBotMessage(error.toString(), {
                widget: 'errorWidget',
              }),
            ],
          }));
        } else {
          setState((prev: any) => ({
            ...prev,
            messages: [
              ...prev.messages,
              createChatBotMessage('An unknown error occurred', {
                widget: 'errorWidget',
              }),
            ],
          }));
        }
      }
    }

    console.log('!!!data', data);

    // if (data && data.message) {
    //   // this is most likely an error
    //   setState((prev: any) => ({
    //     ...prev,
    //     messages: [
    //       ...prev.messages,
    //       createChatBotMessage(data.message ?? 'unknown error', {
    //         widget: 'errorWidget',
    //       }),
    //     ],
    //   }));
    //   return;
    // }

    let newMessages = [];

    if (data && data.message) {
      newMessages.push(createChatBotMessage(data.message, {}));
    }

    if (data && data.objects) {
      console.log('have objects', data.objects);
      const msgs = data.objects.map((obj) => {
        console.log('object', obj);
        if (obj.type === 'task' && obj.taskId) {
          console.log('found task', obj.taskId);
          return createChatBotMessage(obj.message, {
            widget: 'taskWidget',
            payload: {
              actionItemId: obj.taskId,
            },
          });
        }
        return createChatBotMessage(
          `unkown object type ${obj.type} with id ${obj.id}`,
          {}
        );
      });
      newMessages = [...newMessages, ...msgs];
    }

    setState((prev: any) => ({
      ...prev,
      messages: [...prev.messages, ...newMessages],
    }));
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child as React.ReactElement<ChildProps>, {
            actions: { handleHello, sendToLLM },
          });
        }
        return child;
      })}
    </div>
  );
};

export default ActionProvider;
